import axios from "axios";

import Api from "Constants/Apis";
import LocalStoragekeys from "Constants/LocalStoragekeys";
import { getCookie } from "Redux/Actions";

axios.defaults.baseURL = Api.PUBLIC_API_V1;

// axios.defaults.headers.common["Authorization"] = accessToken; > local-storgae

axios.interceptors.request.use(
  async (config) => {
    const token = getCookie(LocalStoragekeys.Access_Token);

    if (config._addToken !== false) {
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
        return config;
      } else {
        return Promise.reject(config);
      }
    } else {
      return config;
    }
  },
  (error) => Promise.reject(error)
);

export { axios };
